import { ViewModel, View, ObservableArray } from "binder"
import { FeeBasePiceManipulationView } from "./feeBasePiceManipulation-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { downloadFile, getAsNumber } from "src/uicomponents/components/utilities";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { DistrictSelector } from "src/erp/enterpriseAdministration/districts/districtManipulation/districtSelector";
import { CurrencySelector } from "src/erp/financial/currencyManipulation/currencySelector";
import { ServerConnection } from "src/server/serverConnection";
import { FileChooser } from "src/common/utilities";

export class FeeBasePiceManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'تنظیم قیمت';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.items = ObservableArray.create<SingleProductPrice>();
        this.dataLoader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation));
        this.districtSelector = new DistrictSelector(this);
        this.districtSelector.onSelectionChanged = d => {
            this.updateExcelUploderStatus();
        }
        this.currencySelector = new CurrencySelector(this);
        this.currencySelector.onSelectionChanged = c => {
            this.updateExcelUploderStatus();
        }
        this.canUploadExcelFile = false;
        this.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new FeeBasePiceManipulationView();
    }
    public getTypeId(): string {
        return "VM-05D7EBB5-B019-4F53-A33E-B274BBC2592F"
    }

    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;
    public set items(v: ObservableArray<SingleProductPrice>) { this._items = v; } public get items(): ObservableArray<SingleProductPrice> { return this._items; } private _items: ObservableArray<SingleProductPrice>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set districtSelector(v: DistrictSelector) { this._districtSelector = v; } public get districtSelector(): DistrictSelector { return this._districtSelector; } private _districtSelector: DistrictSelector;
    public set currencySelector(v: CurrencySelector) { this._currencySelector = v; } public get currencySelector(): CurrencySelector { return this._currencySelector; } private _currencySelector: CurrencySelector;
    public set canUploadExcelFile(v: boolean) { this._canUploadExcelFile = v; } public get canUploadExcelFile(): boolean { return this._canUploadExcelFile; } private _canUploadExcelFile: boolean;

    updateExcelUploderStatus() {
        if (this.districtSelector.selectedItem != null && this.currencySelector.selectedItem != null) {
            this.canUploadExcelFile = true;
        } else {
            this.canUploadExcelFile = false;
        }
    }

    async refresh() {
        this.dataLoader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/SaleServices/GetAllProductCurrentFee', {
                FurtherQueryInfo: filteringInformation
            });
            this.items.update(...result.Prices.map((x, i) => {
                let r = new SingleProductPrice(this);
                r.measuredProductId = x.MeasuredProductId;
                r.productCode = x.ProductCode;
                r.productName = x.ProductName;
                r.currentFee = x.Price;
                r.newFee = x.Price;
                r.index = (result.PaginationInfo.CurrentPage - 1) * result.PaginationInfo.PageCount + i + 1;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);

        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    verify(price: SingleProductPrice): string[] {
        let result: string[] = [];
        if (this.districtSelector.selectedItem == null) {
            result.push('شعبه انتخاب نشده است');
        }
        if (this.currencySelector.selectedItem == null) {
            result.push('واحد پولی انتخاب نشده است');
        }
        if (price.newFee <= 0) {
            result.push('مقدار فی نمی تواند کمتر از صفر باشد.');
        }
        return result;
    }

    async updatePriceFor(price: SingleProductPrice) {
        try {
            let verificationResult = this.verify(price);
            if (verificationResult.length > 0) {
                await this.messageBoxConfirmWarning(verificationResult.join('\n'), 'تنظیم قیمت')
                return;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/SaleServices/SetProductPrice', {
                MeasuredProduct: price.measuredProductId,
                Price: price.newFee,
                CurrencyId: this.currencySelector.selectedItem.id,
                DistrictId: this.districtSelector.selectedItem.id
            });
            if (result.IsSuccessful) {
                await this.messageBoxConfirmSuccess('عملیات با موفقیت انجام شد.', 'تنظیم قیمت');
            } else {
                await this.messageBoxConfirmWarning('خطا در انجام عملیات', 'تنظیم قیمت');
            }
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات', 'تنظیم قیمت');
        } finally {
            this.isLoading = false;
        }

    }

    async downloadExcelTemplate() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/SaleServices/DownloadExcelTemplateForSetFeeBase', {});
            downloadFile(result.ExcelFile, "SetFeeBaseTemplate.xlsx");
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async uploadExcelFile() {
        let fileChooser = new FileChooser();
        let choosedFile = await fileChooser.chooseFile();
        if (choosedFile.isChoosed == false) {
            return;
        }
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/SaleServices/UploadFeeBaseFromExcelFile', {
                ExcelFile: choosedFile.fileContent,
                CurrencyId: this.currencySelector.selectedItem?.id,
                DistrictId: this.districtSelector.selectedItem?.id
            });
            
            if (result.IsSuccessful == false) {
                return
            }

            if (result.IsValidFile == false) {
                downloadFile(result.ExcelFile, "SetFeeBase.xlsx");
                await this.messageBoxConfirmWarning("تعداد از اطلاعات وارد شده نادرست می باشد.", "تنظیم قیمت");
                return;
            }

            await this.messageBoxConfirmSuccess("اطلاعات با موفقیت وارد شد.", "تنظیم قیمت");
            this.refresh();

        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}

export class SingleProductPrice extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: FeeBasePiceManipulationViewModel) {
        super(parent);

        this._typedParent = parent;
    }

    private _typedParent: FeeBasePiceManipulationViewModel;

    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set measuredProductId(v: string) { this._measuredProductId = v; } public get measuredProductId(): string { return this._measuredProductId; } private _measuredProductId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode; } private _productCode: string;
    public set currentFee(v: number) { this._currentFee = v; } public get currentFee(): number { return this._currentFee; } private _currentFee: number;
    public set newFee(v: number) { this._newFee = getAsNumber(v, true); } public get newFee(): number { return this._newFee; } private _newFee: number;

    reset() {
        this.newFee = this.currentFee;
    }

    async update() {
        this._typedParent.updatePriceFor(this);
    }
}